"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent, useRef } from "react";
interface AutoDismissOptions {
  duration: number;
  paused: boolean;
  resetKey: number;
  onExpire: () => void;
}
export function useAutoDismiss(t0) {
  const $ = _c(13);
  const {
    duration,
    paused,
    resetKey,
    onExpire
  } = t0;
  const expire = useEffectEvent(onExpire);
  const remainingRef = useRef(duration);
  let t1;
  if ($[0] !== duration) {
    t1 = () => {
      remainingRef.current = duration;
    };
    $[0] = duration;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== duration || $[3] !== resetKey) {
    t2 = [duration, resetKey];
    $[2] = duration;
    $[3] = resetKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== duration || $[6] !== expire || $[7] !== paused) {
    t3 = () => {
      if (paused || !Number.isFinite(duration)) {
        return;
      }
      const startedAt = Date.now();
      const timer = setTimeout(() => expire(), remainingRef.current);
      return () => {
        clearTimeout(timer);
        remainingRef.current = Math.max(0, remainingRef.current - (Date.now() - startedAt));
      };
    };
    $[5] = duration;
    $[6] = expire;
    $[7] = paused;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== duration || $[10] !== paused || $[11] !== resetKey) {
    t4 = [duration, paused, resetKey];
    $[9] = duration;
    $[10] = paused;
    $[11] = resetKey;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  useEffect(t3, t4);
}